import * as React from 'react';
import {
  Composites,
  TextLabel,
  RichText,
  Illustration,
} from '@wix/wix-base-ui/lib/esm';
import WbuContainer from '../../WbuContainer/WbuContainer';
import type { IWbuEmptyStateProps } from '../WbuEmptyState.props';
import RenderSvg from '../RenderSvg/RenderSvg';
import { TestIds } from '../constants';
import './WbuEmptyState.global.scss';
import { getDataAttributes } from '../../../common/utils';

const WbuEmptyState: React.FC<IWbuEmptyStateProps> = props => {
  const {
    id,
    className,
    label,
    description,
    textButtonLabel,
    url,
    illustration = { svgId: '' },
  } = props;

  const link = (
    <a
      data-hook={TestIds.richTextLink}
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      {textButtonLabel}
    </a>
  );

  return (
    <WbuContainer id={id} {...getDataAttributes(props)} className={className}>
      <Composites.RichTextWithIllustrationVertical>
        <Illustration>
          {!!illustration && <RenderSvg svgId={illustration.svgId} />}
        </Illustration>
        <Composites.RichTextLabeled>
          <TextLabel value={label} type="T09" />
          <RichText type="T02">
            {description}
            <br />
            {link}
          </RichText>
        </Composites.RichTextLabeled>
      </Composites.RichTextWithIllustrationVertical>
    </WbuContainer>
  );
};

export default WbuEmptyState;
